import createFetchTypes from '@app/utils/createFetchTypes';

const mainType = 'TEAMS';

export const getTeamsTypes = createFetchTypes(`${mainType}_GET_TEAMS`);

export const getTeamsByStorytellerTypes = createFetchTypes(
	`${mainType}_GET_TEAMS_BY_STORYTELLER`,
);

export const getTeamByIdTypes = createFetchTypes(`${mainType}_GET_TEAM_BY_ID`);

export const createTeamTypes = createFetchTypes(`${mainType}_CREATE_TEAM`);

export const deleteTeamTypes = createFetchTypes(`${mainType}_DELETE_TEAM`);
export const updateTeamTypes = createFetchTypes(`${mainType}_UPDATE_TEAM`);

export const updateStorytellerTeamsTypes = createFetchTypes(
	`${mainType}_UPDATE_STORYTELLER_TEAMS`,
);

export const addStorytellerToTeamTypes = createFetchTypes(
	`${mainType}_ADD_STORYTELLER_TO_TEAM`,
);

export const removeStorytellersFromTeamTypes = createFetchTypes(
	`${mainType}_REMOVE_STORYTELLERS_FROM_TEAM`,
);

export const removeAudienceFromTeamTypes = createFetchTypes(
	`${mainType}_REMOVE_AUDIENCE_FROM_TEAM`,
);

export const getPhoneNumbersType = createFetchTypes(
	`${mainType}_GET_PHONE_NUMBERS`,
);

export const assignPhoneToTeamType = createFetchTypes(
	`${mainType}_ASSIGN_PHONE_NUMBER_TO_TEAM`,
);
